import { defineSlotRecipe } from "@pandacss/dev";
export const slots = ["root", "hintText"];

export const aromaField = defineSlotRecipe({
  className: "aroma-field",
  jsx: ["Field"],
  slots,
  base: {
    root: {
      width: "100%",
    },
    hintText: {
      paddingTop: "padding.1",
      display: "flex",
      gap: "gap.1",
      alignItems: "center",
      textStyle: "paragraph.m.regular",
      color: "content.neutral.base.subtlest",
      _disabled: {
        color: "content.neutral.base.disable",
      },
    },
  },
  variants: {
    status: {
      error: {
        hintText: {
          color: "content.functional.error",
        },
      },
      warning: {
        hintText: {
          color: "content.functional.warning",
        },
      },
      success: {
        hintText: {
          color: "content.functional.sucess",
        },
      },
      loading: {
        hintText: {
          color: "content.neutral.base.subtlest",
        },
      },
    },
  },
});
